import { Fragment, ReactNode } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { PageHeader } from "../../components/PageHeader";
import { useIntl } from "../../contexts/IntlContext";
import { HELP_PROCESSES } from "./processes";

/** Transforma `**texto**` em negrito — usado pro nome de botões/telas. */
function renderRichText(text: string): ReactNode {
  return text.split("**").map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index}>{part}</strong>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    ),
  );
}

export default function Help() {
  const intl = useIntl();

  return (
    <>
      <PageHeader title={intl.formatMessage({ id: "help.title" })} />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {intl.formatMessage({ id: "help.subtitle" })}
      </Typography>
      {HELP_PROCESSES.map((process, index) => (
        <Accordion key={process.id} defaultExpanded={index === 0} disableGutters>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1" fontWeight={600}>
              {process.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="ol" sx={{ pl: 3, m: 0, "& li": { mb: 1 } }}>
              {process.steps.map((step) => (
                <li key={step}>
                  <Typography variant="body2">{renderRichText(step)}</Typography>
                </li>
              ))}
            </Box>
            {process.notes?.length ? (
              <>
                <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                  {intl.formatMessage({ id: "help.notes" })}
                </Typography>
                <Box component="ul" sx={{ pl: 3, m: 0, "& li": { mb: 1 } }}>
                  {process.notes.map((note) => (
                    <li key={note}>
                      <Typography variant="body2">{renderRichText(note)}</Typography>
                    </li>
                  ))}
                </Box>
              </>
            ) : null}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}
